/* eslint-disable func-names */
/* eslint-disable react/no-this-in-sfc */
import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { mensagemCampoObrigatorio } from '@core/util/mensagemUtil';
import { cancelarAlert } from 'app/services/alerts';
import { FormikProvider, useFormik } from 'formik';
import moment from 'moment';
import React, { useContext, useEffect } from 'react';
import { FaArrowCircleUp } from 'react-icons/fa';
import * as yup from 'yup';
import { ContaReceberContext } from '../../contaReceberContext';
import ContaReceberForm from '../ContaReceberForm';
import { contaReceberModais } from './contaReceberModais';

const MOMENT_HOJE = moment();

const ContaReceberCadastroModal = ({ onSubmit, origemConciliacao = false }) => {
  const [modal, setModal] = useContext(ContaReceberContext).modal;
  const [contaReceber, setContaReceber] = useContext(ContaReceberContext).contaReceberAtual;

  const [page] = useContext(ContaReceberContext).page;
  const [search] = useContext(ContaReceberContext).search;
  const [size] = useContext(ContaReceberContext).size;
  const [sort] = useContext(ContaReceberContext).sort;
  const [filtroAvancado] = useContext(ContaReceberContext).filtroAvancado;

  const onSubmitForm = async (data) => {
    if (!(data?.valorEmAberto < 0)) {
      const contaReceber = JSON.parse(JSON.stringify(data));

      if (contaReceber?.cliente) {
        contaReceber.clientePessoaId = contaReceber.cliente.pessoaId;
        delete contaReceber.cliente;
      }

      if (contaReceber?.categorias?.length) {
        contaReceber.categorias = contaReceber.categorias.map(({ id, valorBruto, classe, rateios }) => ({
          id,
          valorBruto,
          classeId: classe?.id,
          classe: {
            id: classe?.id,
            indice: classe?.indice,
            nome: classe?.nome,
            natureza: classe?.natureza,
            nivel: classe?.nivel,
          },
          rateios: rateios,
        }));
      }

      if (contaReceber?.conta) {
        contaReceber.contaId = contaReceber.conta.id;

        if (contaReceber.baixa) {
          contaReceber.baixa.contaId = contaReceber.contaId;
        }

        delete contaReceber.conta;
      }

      if (!contaReceber.baixar && contaReceber.baixa) {
        delete contaReceber.baixa;
      }

      if (contaReceber.baixa) {
        if (contaReceber.baixa.juros?.valorBruto === null || contaReceber.baixa.juros?.valorBruto === undefined) {
          delete contaReceber.baixa.juros;
        }
        if (contaReceber.baixa.multa?.valorBruto === null || contaReceber.baixa.multa?.valorBruto === undefined) {
          delete contaReceber.baixa.multa;
        }
        if (
          contaReceber.baixa.correcaoMonetaria?.valorBruto === null ||
          contaReceber.baixa.correcaoMonetaria?.valorBruto === undefined
        ) {
          delete contaReceber.baixa.correcaoMonetaria;
        }
        if (contaReceber.baixa.desconto?.valorBruto === null || contaReceber.baixa.desconto?.valorBruto === undefined) {
          delete contaReceber.baixa.desconto;
        }

        contaReceber.baixas = [contaReceber.baixa];

        delete contaReceber.baixa;
      }

      if (!contaReceber.repetirLancamento) {
        delete contaReceber.recorrencia;
      }

      const res = await onSubmit(contaReceber, { page, q: search, size, sort, filtroAvancado });

      if (res) {
        formik.resetForm(getInitialValues({}));
        setContaReceber({});
        setModal('');
      }
    }
  };

  const getInitialValues = (registro) => ({
    ...registro,
    mesCompetencia: registro?.mesCompetencia ? registro.mesCompetencia : MOMENT_HOJE,
    baixar: !!registro?.baixa,
    cliente: registro?.cliente
      ? {
          id: registro.cliente.id,
          nome: registro.cliente?.pessoa?.nome || registro.cliente?.nome,
          pessoaId: registro.cliente?.pessoa?.id || registro.cliente?.pessoaId,
        }
      : null,
    categorias: registro?.categorias?.length ? registro.categorias : [{}],
    tipo: 'UNICA',
  });

  const formik = useFormik({
    initialValues: getInitialValues(contaReceber),
    onSubmit: onSubmitForm,
    validateOnChange: true,
    validationSchema: yup.object().shape({
      mesCompetencia: yup
        .string()
        .nullable()
        .required(mensagemCampoObrigatorio('a competência')),
      cliente: yup
        .object()
        .nullable()
        .required(mensagemCampoObrigatorio('o cliente')),
      categorias: yup.array().of(
        yup.object().shape({
          id: yup.string().nullable(),
          classe: yup
            .object()
            .nullable()
            .required(mensagemCampoObrigatorio('a categoria'))
            .test('classe', mensagemCampoObrigatorio('a categoria'), function(classe) {
              return !!classe && !!classe?.id;
            }),
          valorBruto: yup
            .number()
            .nullable()
            .min(0.01, 'O valor deve ser maior que zero.')
            .required(mensagemCampoObrigatorio('o valor bruto')),
        })
      ),
      dataVencimento: yup
        .date()
        .nullable()
        .required(mensagemCampoObrigatorio('a data de vencimento')),
      dataEmissao: yup.date().nullable(),
      conta: yup
        .object()
        .nullable()
        .test('contaNotNull', mensagemCampoObrigatorio('a conta'), function(conta) {
          if (this.parent?.baixar || !!this.parent?.nossoNumero) {
            return !!conta?.id;
          }
          return true;
        }),
      baixa: yup.object().when('baixar', {
        is: true,
        then: yup.object().shape({
          dataRecebimento: yup
            .date()
            .nullable()
            .required(mensagemCampoObrigatorio('a data de recebimento'))
            .test('dataRecebimento', mensagemCampoObrigatorio('a data de recebimento'), function(dataRecebimento) {
              return !!dataRecebimento;
            }),
          dataLiquidacao: yup
            .date()
            .nullable()
            .required(mensagemCampoObrigatorio('a data da liquidação'))
            .min(yup.ref('dataRecebimento'), 'A data de liquidação não pode ser inferior à data de recebimento.'),
          valorRecebido: yup
            .number()
            .nullable()
            .min(0.01, 'O valor deve ser maior que zero.')
            .required(mensagemCampoObrigatorio('o valor')),
          formaRecebimento: yup
            .string()
            .nullable()
            .required(mensagemCampoObrigatorio('a forma de recebimento')),
        }),
      }),
      recorrencia: yup.object().when('repetirLancamento', {
        is: true,
        then: yup.object().shape({
          frequencia: yup
            .string()
            .nullable()
            .required(mensagemCampoObrigatorio('a frequência')),
          quantidade: yup
            .number()
            .nullable()
            .required(mensagemCampoObrigatorio('a quantidade')),
        }),
      }),
    }),
  });

  const { resetForm } = formik;
  useEffect(() => {
    resetForm({
      values: getInitialValues(contaReceber),
    });
  }, [contaReceber, resetForm]);

  const handleClose = () => {
    const close = () => {
      formik.resetForm(getInitialValues({}));
      setContaReceber({});
      setModal('');
    };

    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };

  return (
    <SimpleDialog fullScreen open={modal === contaReceberModais.editarContaReceber} onClose={handleClose} innerScroll>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          fullScreen
          header={{
            title: 'Lançamento de contas a receber',
            icon: <FaArrowCircleUp />,
            toolbar: (
              <>
                <CancelButton title="cancelar" type="button" onClick={handleClose}>
                  Cancelar
                </CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Salvar
                </SaveButton>
              </>
            ),
          }}
          content={<ContaReceberForm origemConciliacao={origemConciliacao} />}
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

export default ContaReceberCadastroModal;
